module.exports = __webpack_public_path__ + "img/Menu-01.dfff3ca8.png";